import tolgee from '@/plugins/tolgee'
import isURL from 'validator/lib/isURL'

export const rules = {
  maxlength:
    (maxLength = 200) =>
    (v: string) =>
      (v || '').length <= maxLength ||
      tolgee.t('validations.maxLength', { maxLength, ns: 'local' }),
  minlength: (minLength: number) => (v: any) =>
    !((v || '').length > 0 && (v || '').length < minLength) ||
    tolgee.t('validations.minLength', { minLength, ns: 'local' }),
  maxValue:
    (maxValue = Number.MAX_SAFE_INTEGER) =>
    (v: number) =>
      Number(v) <= maxValue || tolgee.t('validations.maxValue', { maxValue, ns: 'local' }),
  url: (value: string) => {
    if (value) {
      return isURL(value) || tolgee.t('validations.url', { ns: 'local' })
    }

    return !value
  },
  required: (value: any) => !!value || tolgee.t('validations.required', { ns: 'local' }),
  email: (value: string) => {
    const pattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    return pattern.test(value) || tolgee.t('validations.email', { ns: 'local' })
  },
}
